import { tenantTimeZone } from "./tenantTimeZone";
export interface MonthObject {
  id: number;
  short: string;
  long: string;
}

export const checkIfDateInRange = (start: Date, end: Date, testDate: Date) => {
  return (
    testDate.getDate() >= start.getDate() && testDate.getDate() <= end.getDate()
  );
};

export enum DATE_OPTIONS {
  full,
  short,
  dMY,
  dM,
}

export const formatDate = (date: Date, options: DATE_OPTIONS) => {
  let _options: Intl.DateTimeFormatOptions = {};
  switch (options) {
    case DATE_OPTIONS.full:
      _options = {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      break;

    case DATE_OPTIONS.short:
      _options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      break;

    case DATE_OPTIONS.dMY:
      _options = {
        // weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      };
      break;
    case DATE_OPTIONS.dM:
      _options = {
        month: "short",
        day: "numeric",
      };
      break;

    default:
      break;
  }
  // let options: Intl.DateTimeFormatOptions = {
  //   weekday: "long",
  //   year: "numeric",
  //   month: "short",
  //   day: "numeric",
  // };
  // In the CLIENT's zone, never the browser's: a candidate abroad still sees the client's day (tenantTimeZone.ts).
  return date.toLocaleDateString("en-CA", { ..._options, timeZone: tenantTimeZone() });
};

export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(" ");
};
